export default __webpack_public_path__ + "static/media/hero-right-3.ed676656.png";